const STORAGE_KEY = 'geniusmind_pending_affiliate_click';

// Fallback attribution for a visitor who clicks an affiliate link (?aff=CODE)
// before they're logged in — the code is re-submitted to /affiliates/track
// once they authenticate (see context/useAuthStore.js). Mirrors
// utils/bookReferral.js's pending-referral pattern, kept as a separate key so
// an affiliate click and a refer-a-friend click never clobber each other.
export function getPendingAffiliateClick() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setPendingAffiliateClick(code, bookId) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ code, bookId }));
  } catch {
    // Storage unavailable (private mode, quota) — attribution just won't
    // survive a login redirect; not worth surfacing to the user.
  }
}

export function clearPendingAffiliateClick() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // See setPendingAffiliateClick.
  }
}
